import { Directive, Inject, Input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { COMMONS_ENV } from '@damofire/data-angular-commons';

@Directive({ selector: '[appHideOnRepairMode]', standalone: true })
export class HideOnRepairModeRepairDirective implements OnChanges {
  @Input()
  appHideOnRepairMode: boolean | string;

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    @Inject(COMMONS_ENV) private readonly environment: any,
  ) {
    this.showOrHide();
  }

  ngOnChanges() {
    this.showOrHide();
  }

  private showOrHide(): void {
    this.viewContainer.clear();

    if (!this.environment.repairMode) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
